import * as React from "react"

import { cn } from "@/lib/utils"

// Smart defaults applied based on `type`, to fix mobile keyboard and iOS behaviour
// across the whole app without having to touch 400+ individual inputs.
// Explicit props always win (spread order at the end).
const TYPE_DEFAULTS = {
  email: {
    inputMode: "email",
    autoComplete: "email",
    autoCapitalize: "off",
    autoCorrect: "off",
    spellCheck: false,
  },
  tel: {
    inputMode: "tel",
    autoComplete: "tel",
    autoCapitalize: "off",
    autoCorrect: "off",
    spellCheck: false,
  },
  password: {
    autoCapitalize: "off",
    autoCorrect: "off",
    spellCheck: false,
  },
  url: {
    inputMode: "url",
    autoCapitalize: "off",
    autoCorrect: "off",
    spellCheck: false,
  },
  search: {
    inputMode: "search",
    autoComplete: "off",
  },
}

const Input = React.forwardRef(({ className, type, inputMode, ...props }, ref) => {
  const { inputMode: defaultInputMode, ...defaults } = TYPE_DEFAULTS[type] || {}
  // For type="number" we keep number semantics but hint mobile keyboard to show
  // the numeric pad (without arrows). Caller can still pass inputMode to override.
  const resolvedInputMode = inputMode ?? defaultInputMode ?? (type === "number" ? "decimal" : undefined)

  return (
    <input
      type={type}
      {...defaults}
      {...props}
      inputMode={resolvedInputMode}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref} />
  );
})
Input.displayName = "Input"

export { Input }
